module.exports = __webpack_public_path__ + "img/content2.82568df8.png";